module.exports = __webpack_public_path__ + "fcaba86e59ca52b849276f39e378965e.svg";